import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/cetaphilmm/footer';
import Header from '../components/cetaphilmm/header';
import HomePage from '../pages/cetaphilmm/home_page';
import AboutPage from '../pages/cetaphilmm/about_page';
import ContactPage from '../pages/cetaphilmm/contact_page';

export default function CetaphilTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
            />
            <Footer />
        </React.Fragment>
    )
}
